import { FaWallet, FaChevronDown, FaUser } from 'react-icons/fa';
import ProfileDropdown from './ProfileDropdown';
import BalanceDropdown from './BalanceDropdown';
import { useUserInfo } from '@/hooks/useUserInfo';
import { Link } from 'react-router-dom';

const HeaderActions = () => {
  const { username, mainBalance, withdrawableBalance, exposureBalance } = useUserInfo();

  return (
    <div className="flex items-center gap-2">
      {/* Deposit Button */}
      <Link
        to="/deposit"
        className="hidden lg:flex items-center gap-2 bg-[#13AE52] px-3 py-[6px] rounded text-white text-[12px] font-extrabold uppercase"
      >
        <FaWallet size={14} />
        Deposit
      </Link>

      {/* ✅ Balance Dropdown */}
      <div className="relative group">
        {/* Button */}
        <div className="flex items-center gap-2 bg-[#FFC600] px-3 py-[6px] rounded text-black text-[12px] font-extrabold cursor-pointer">
          <span> {mainBalance ?? 0}</span>
          <FaChevronDown size={12} />
        </div>

        {/* Dropdown */}
        <div className="absolute right-0 top-full pt-2 opacity-0 invisible group-hover:visible group-hover:opacity-100 transition-all duration-200 z-50">
          <BalanceDropdown
            mainBalance={mainBalance}
            withdrawableBalance={withdrawableBalance}
            exposure={exposureBalance}
          />
        </div>
      </div>

      {/* User Dropdown */}
      <div className="max-lg:hidden relative group">
        <div className="flex items-center gap-2 bg-[#FFC600] px-3 py-[6px] rounded text-black text-[12px] font-semibold cursor-pointer">
          <FaUser size={12} />
          <span>{username}</span>
          <FaChevronDown size={12} />
        </div>

        <div className="absolute right-0 top-full pt-2 opacity-0 invisible group-hover:visible group-hover:opacity-100 transition-all duration-200 z-50">
          <ProfileDropdown />
        </div>
      </div>
    </div>
  );
};

export default HeaderActions;
